module fdm.flightSegment {

    export class ecmEngineParamChartController {


        public queryResult: any;
        public query: any;
        public data: any;
        public layout: any;
        public options: any;
        public events: any;
        public loading: any;
        private generalParameter: string;

        public constructor(
            private $scope: any,
            private $filter: ng.IFilterService
        ) {

        }

        $onChanges(changes) {
            if (changes.queryResult && changes.queryResult.currentValue) {
                this.generateChart();
            }
        }

        public static generateTrace = (traceName: string, xValues, yValues, yAxis, color: string) => {
            let trace: any = {
                x: xValues,
                y: yValues,
                yaxis: yAxis,
                name: traceName,

                marker: {
                    color: color
                },
                //line: {
                //    width: 1
                //},
                type: 'scatter'

            };
            if (yValues.length == 0) {
                trace.y = Array.apply(null, Array(xValues.length)).map(Number.prototype.valueOf, 0);
            }

            return trace;
        }

        public generateChart = () => {
            const colors = ["#4AAFF4", "#D8D927", "#F6810A", "#CE1955", '#F05050'];

            const specificParamValues = {};

            this.queryResult.flightSegments
            // .sort((first, second) => (new Date(first.legDate).getTime() - new Date(second.legDate).getTime()))
            .forEach(flightSegment => {

                const byGeneralParam = flightSegment.parameterValues.filter(parameterValue => parameterValue.generalParameterName === this.generalParameter);

                byGeneralParam.forEach(param => {
                    if (!specificParamValues[param.specificParameterName]) {
                        specificParamValues[param.specificParameterName] = {
                            generalParameterName: param.generalParameterName,
                            specificParameterName: param.specificParameterName,
                            x: [],
                            y: []
                        };
                    }

                    // const xValue = flightSegment.legDate.substr(0, 13);
                    const xValue = flightSegment.legDate;//this.$filter('date')(new Date(flightSegment.legDate), "HH:mm MMM dd, yyyy");
                    specificParamValues[param.specificParameterName].x.push(xValue);
                    specificParamValues[param.specificParameterName].y.push(param.value);
                });
            });

            const traceData = Object.values(specificParamValues).map((paramValues, ind) => {
                const valuesTrace = fdm.flightSegment.ecmEngineParamChartController.generateTrace((paramValues as any).specificParameterName, (paramValues as any).x, (paramValues as any).y, `y_${(paramValues as any).generalParameterName.toLowerCase()}`, colors[ind]);
                return valuesTrace;
            })
            this.data = traceData;
            this.layout = {
                height: 350,
                margin: {
                    t: 10,
                    b: 40,
                    l: 35,
                    r: 0
                },
                dragmode: 'pan',
                xaxis: {
                    type: 'date',
                    automargin: true,
                    // fixedrange: true,
                },
                yaxis: {
                    fixedrange: true,
                    automargin: true
                },
                // showlegend: false,
                legend: {
                    xanchor: "left",
                    yanchor: "top",
                    orientation: "h",
                    y: 1.13,
                    x: 0
                },
            };

            if (this.data.length === 0) {
                this.layout.xaxis.visible = false;
                this.layout.yaxis.visible = false;
                this.layout.annotations = [
                    {
                        text: "No data",
                        xref: "paper",
                        yref: "paper",
                        showarrow: false,
                        font: {
                            "size": 28
                        }
                    }
                ];
            }

            this.options = {
                scrollZoom: false,
                displayModeBar: true,
                displaylogo: false,
                doubleClick: 'autosize',
                staticPlot: false,
                modeBarButtonsToRemove: [ 'resetScale2d', 'lasso2d', 'select2d', 'sendDataToCloud', 'toggleSpikelines'],
                
            };


        }
    }


    angular.module('fdm.flightSegment').component('ecmEngineParamChart', {
        bindings: {
            queryResult: '<',
            loading: '<',
            query: '<',
            generalParameter: '<'
        },
        controller: ecmEngineParamChartController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart-instance.html'
    });
}